module.exports = __webpack_public_path__ + "static/media/0026_IMG_LES_ENSEIGNES_LE_BOUCHER_RELIEF.eb11a2b9.png";